"use client";

import * as React from "react";
import { ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TrustAndRotDeduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section id="trust-and-rot-deduction" className="w-full bg-secondary py-16 md:py-24 px-4 md:px-8">
      <div className="container mx-auto max-w-4xl">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="border-border/50 shadow-lg bg-card">
            <CardHeader className="flex flex-col items-center gap-5 pb-4 pt-8 md:pt-12">
              <div className="p-4 bg-primary/10 rounded-lg">
                <ShieldCheck className="w-10 h-10 text-primary" strokeWidth={1.5} />
              </div>
              <CardTitle asChild>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-default text-center text-foreground leading-tight max-w-3xl">
                  Fast pris, skriftliga garantier och giltigt våtrumsintyg i Karlstad
                </h2>
              </CardTitle>
            </CardHeader>
            <CardContent className="text-center pb-8 md:pb-12 px-6 md:px-12">
              <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-3xl mx-auto">
                Vi tror på fullständig transparens. Därför arbetar vi alltid med fast pris och skriftliga garantier. När din badrumsrenovering är färdigställd överlämnar vi ett giltigt våtrumsintyg – din juridiska värdehandling gentemot försäkringsbolag och vid framtida försäljning. Som privatperson i Karlstad nyttjar du självklart ROT-avdraget direkt på fakturan vilket drar ner arbetskostnaden med upp till 30 %.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}